import { map } from 'lodash'

const ingredientOverridesIngredientsDetailsFormInitialValues =
  overridesIngredients => ({
    overridesIngredientIds: map(overridesIngredients, ({ id, name }) => ({
      value: id,
      title: name,
    })),
  })

export default ingredientOverridesIngredientsDetailsFormInitialValues
